/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { NoOptionsNetworkError } from './NoOptionsNetworkError';
import { UseQueryResult } from 'react-query';
import { InvalidConsideredOption, Option, Problem } from '../../types';
import { wrapper } from '../../sharedStyles';
import { GenericNoOptions } from './GenericNoOptions';
import { Text } from '@cimpress-ui/react';

type NoOptionsProps = {
  routingProblem: Problem | undefined;
  options: UseQueryResult<Option | InvalidConsideredOption, Error>[];
  orderedSkuCode: string | undefined;
  routingRequestUrl: string | undefined;
  halfWeight?: boolean;
};

export const NoOptions = ({
  routingProblem,
  options,
  orderedSkuCode,
  routingRequestUrl,
  halfWeight,
}: NoOptionsProps) => {
  const noFulfillmentOptionWrapper = css`
    padding: 1.6rem 0;

    &.halfWeight {
      padding: 1.2rem 0;
    }

    > h3.halfWeight {
      font-size: 1.3rem;
    }

    > * {
      padding: 0 1.6rem; // apply left/right padding to the direct children so the scrollbar doesn't overlap them on short height screens
    }
  `;

  if (routingProblem && options.length === 0) {
    return (
      <div
        css={[wrapper, noFulfillmentOptionWrapper]}
        className={halfWeight ? 'halfWeight' : undefined}
        data-testid="network-error-no-fulfillment-options"
      >
        <Text as="h3" UNSAFE_className={halfWeight ? 'halfWeight' : undefined}>
          Fulfillment Options
        </Text>
        <NoOptionsNetworkError
          routingProblem={routingProblem}
          routingRequestUrl={routingRequestUrl}
          halfWeight={halfWeight}
        />
      </div>
    );
  }

  return (
    <div
      css={[wrapper, noFulfillmentOptionWrapper]}
      className={halfWeight ? 'halfWeight' : undefined}
      data-testid="generic-no-fulfillment-options"
    >
      <h3 className={halfWeight ? 'halfWeight' : undefined}>Fulfillment Options</h3>
      <GenericNoOptions orderedSkuCode={orderedSkuCode} halfWeight={halfWeight} />
    </div>
  );
};
